import * as React from "react";
import { useDispatch } from "react-redux";

import * as userActions from "./../redux/user/actionTypes";

export const AuthContext = React.createContext(null);

export const AuthProvider = ({ children }) => {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const isLoggedIn = React.useRef(user ? Boolean(user.id) : false);
  const [sessionExpired, setSessionExpired] = React.useState(false);
  const dispatch = useDispatch();

  const auth = {
    isLoggedIn,
    sessionExpired,
    login(email, password) {
      return new Promise((res, rej) => {
        dispatch({
          type: userActions.AUTH_API_LOGIN_REQUEST,
          email,
          password,
          isLoggedIn,
          res,
          rej,
        });
      });
    },
    logout() {
      return new Promise((res, rej) => {
        dispatch({
          type: userActions.AUTH_API_LOGOUT_REQUEST,
          isLoggedIn,
          res,
          rej,
        });
      });
    },
    startRefreshTokenSaga() {
      const delay = 25 * 60 * 1000; // 25 minutes
      setInterval(() => {
        if (isLoggedIn.current) {
          dispatch({
            type: userActions.AUTH_API_REFRESH_ACCESS_TOKEN,
            logout: auth.logout,
            setSessionExpired,
          });
        }
      }, delay);
    },
  };

  if (isLoggedIn.current) auth.startRefreshTokenSaga();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return React.useContext(AuthContext);
};
